<template>
  <div class="real-auth-result" >
     <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          class="navbar"
          left-arrow
          title="实人认证"
          @click-left="closePage"
      >
      </z-nav-bar>
    </z-fix-top>

    <section v-if="!intermediate">
      <img v-if="result === 'true'" :src="$setPicSize(successImg)" :class="[isHeroClub ? 'heroClubImg' : '']"/>
      <img v-if="result === 'false'" :src="$setPicSize(failImg)" :class="[isHeroClub ? 'heroClubImg' : '']"/>
      <div class="result-info">
        <header v-if="result === 'true'">恭喜您认证成功</header>
        <header v-if="result === 'false'">很遗憾认证失败</header>
        <div class="desc">{{ resInfo }}</div>
      </div>
      <div class="operation-area">
        <div v-for="ctx in adapterButtonCtxes(buttonCtxes)" :key="ctx.type" :class="ctx.style">
          <z-button @click="doCommand(ctx)" size="small-detail" :text="ctx.text" :style="isHeroClub && ctx.style == 'highlight' ? heroClubButtonStyle : {}"></z-button>
        </div>
      </div>
    </section>

    <section v-if="intermediate">
      <img :src="$setPicSize(intermediateInfo.picUrl)" />
      <div class="result-info">
        <header>{{intermediateInfo.title}}</header>
        <div class="desc">{{ intermediateInfo.content }}</div>
      </div>
      <div class="operation-area">
        <div v-for="ctx in adapterButtonCtxes(intermediateInfo.retButtons)" :key="ctx.type" :class="ctx.style">
          <z-button @click="doCommand(ctx)" size="small-detail" :text="ctx.text" :style="isHeroClub && ctx.style == 'highlight' ? heroClubButtonStyle : {}"></z-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { NavBar, Button, FixTop } from '@zz-common/zz-ui';
import native from '@zz-common/native-adapter'
import { setPicSize } from '@zz-common/zz-utils'
import { getsdkcallbacktext } from '@api/resourceApi'
import { queryParams, getCookie, isHeroClubByUa } from '../../../lib/utils'

const query = queryParams()

export default {
  name: 'ResultComp',
  data() {
    return {
      sourcecode: query.sourcecode || this.$route.query.sourcecode || '',
      strategyid: query.strategyid || this.$route.query.strategyid,
      txCode: query.code || this.$route.query.code,
      agreementNo: query.agreementNo || this.$route.query.agreementNo,
      authtype: query.authtype || this.$route.query.authtype || '', //  认证类型challenge代表二次挑战认证
      isInter: query.intermediate || this.$route.intermediate || '', //是否是拦截状态
      result: '',
      resInfo: '',
      buttonCtxes: [],
      intermediate: '', //其他业务结果拦截 json字符串
      isHeroClub: isHeroClubByUa(),
      heroClubButtonStyle: {
        background: '#111111',
        color: '#F2D3A9',
        border: '1px solid #111111'
      }
    }
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button
  },
  computed: {
    successImg() {
      return this.isHeroClub ? '629bc05a-e027-42ae-868c-0ecab5e37727.png' : 'f9436be4-ddfb-4f7b-8047-f0ae914e714c.png'
    },
    failImg() {
      return this.isHeroClub ? '4a08eb38-fe9d-476a-9aca-2d9fcddbb403.png' : '2980c180-8a0e-48e5-9ffb-ec7ad3ec4766.png'
    },
    intermediateInfo() {
      let res = {}
      try {
        res = JSON.parse(this.intermediate)
      } catch (err) {
        console.log(err)
      }
      return res
    }
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    },
    adapterButtonCtxes(data) {
      if (!Array.isArray(data)) return []
      const buttonData = data.map((b) => {
        return {
          cmd: b.type,
          targetUrl: b.mUrl,
          text: b.buttonDesc,
          style: b.style || 'normal'
        }
      })
      return buttonData
    },
    closePage() {
      native.close()
    },
    doCommand(ctx) {
      if (ctx.cmd === 'close') {
        native.close()
      } else if (ctx.cmd === 'jump') {
        native.skipToUrl({
          targetUrl: ctx.targetUrl,
          needClose: '1'
        })
      } else if (ctx.cmd === 'audit') {
        this.$router.replace({
          path: '/realauth/verifyface/commit',
          query: {
            sourcecode: this.sourcecode,
            strategyid: this.strategyid
          }
        })
      } else if (ctx.cmd === 'reverify') {
        this.$router.replace({
          path: '/realauth/verifyface/verify',
          query: {
            sourcecode: this.sourcecode,
            agreementNo: this.agreementNo,
            strategyid: this.strategyid
          }
        })
      }
    }
  },
  created() {
    getsdkcallbacktext({
      sourcecode: this.sourcecode,
      strategyid: this.strategyid,
      code: this.txCode,
      agreementNo: this.agreementNo,
      intermediate: this.isInter
    })
      .then((res) => {
        console.info(res)
        this.result = res.isPass
        this.resInfo = res.copywriting
        this.intermediate = res.intermediate
        this.buttonCtxes = res.retButtons
        if (this.result === 'true') {
          native.wrap('sendNotification')({
            name: 'ZZ_NOTIFICATION_REAL_CERTIFICATION_SUCCESS',
            args: JSON.stringify({ userId: getCookie('uid') })
          })
        }
      })
      .catch((err) => {
        console.error(err)
        this.$toast(err)
      })
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
